import bug from "../images/lambdabug.jpg";
import wash from "../images/expresswash.jpg";
import life from "../images/gameoflife.jpg";
import acts from "../images/randomActs.PNG";

export const data = [
  {
    projectImage: acts,
    title: "Random Acts",
    description:
      "This was one of my very first web development projects. The objective was to create a multi-page responsive marketing website for an application called Random Acts Generator. The technologies used in this site are HTML, CSS, Javascript, and LESS. I had a lot of fun with this project creating a login popup and a video carousel in javascript using D.O.M. manipulation techniques. It was also a learning experience on styling and css animations.",
    projectUrl: "https://blissful-ramanujan-e6e4a8.netlify.app/",
    githubUrl: "https://github.com/cladams0203/Marketing_Random-Acts-Generator",
  },
  {
    projectImage: wash,
    title: "Express Wash",
    description:
      "This was a labs project that I did with 7 team members.  It is a web and iOS based application to connect clients that would like a mobile car wash to mobile detailers in the area.  The technologies used on this are Redux, React, Node, Postgresql, Mapbox, Multer, and Styled-Components.  I learned a lot about AWS and a multitude of their services while doing this project. Such as Elastic Beanstalk, S3, Amplify, IAM, Route53, Code Pipeline, and RDS. I also did all of the unit testing for the project using Jest and RTL with github actions to trigger the test runners for branch protection.",
    projectUrl: "https://www.expresswash.us/",
    githubUrl: "https://github.com/Express-Wash",
  },
  {
    projectImage: life,
    title: "Game of Life",
    description:
      "This is a project I did during the Computer Science portion of my education.  I built it using react and conflux as a state management system. It implements the rules found in Conway's Game of Life.  I used an algorithm to generate a 2D array between generations of cells and then rendered the array to the screen.  The app also has some popular presets as well as random, size, and speed features.",
    projectUrl: "https://gameofspacelife.netlify.app/",
    githubUrl: "https://github.com/cladams0203/game-of-life",
  },
  {
    projectImage: bug,
    title: "Bug Tracker",
    description:
      "A Hackathon project with 8 team members.  We were asked to build a production app from the ground up in 30 hours.  Our solution was a bug tracking app similar to Jira. We used React, Redux, React DnD, Firebase and Node for this project.,",
    projectUrl: "https://lambda-bug-tracker.firebaseapp.com/",
    githubUrl: "https://github.com/Lambda-Bug-Tracker",
  },
];
